import { Link, useNavigate } from 'react-router-dom';

import { useTranslation } from '../../i18n/useTranslation.js';
import { Badge } from '../ui/Badge.jsx';
import { Button } from '../ui/Button.jsx';

/**
 * Shared detail-page header: back link, title, status badge, actions,
 * optional metric strip (`metrics`: array of { label, value }).
 */
export function DetailHeader({ backTo, title, status, actions, metrics }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function goBack() {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  }

  return (
    <>
      <header className="page-header">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)', minWidth: 0 }}>
          {backTo ? (
            <Link to={backTo} className="muted text-sm" style={{ textDecoration: 'none' }}>
              ← {t('detail.back')}
            </Link>
          ) : (
            <Button size="sm" variant="ghost" onClick={goBack}>← {t('detail.back')}</Button>
          )}
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-3)', flexWrap: 'wrap' }}>
            <h1 style={{ margin: 0 }}>{title}</h1>
            {status && <Badge status={status} />}
          </div>
        </div>
        {actions && <div className="page-actions">{actions}</div>}
      </header>
      {Array.isArray(metrics) && metrics.length > 0 && (
        <div className="detail-metrics">
          {metrics.map((m) => (
            <div key={m.label} className="detail-metric">
              <span className="metric-label">{m.label}</span>
              <span className="metric-value">{m.value}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
